var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.3 9c-.4-.4-1-.4-1.4 0L12 12.9 8.1 9c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.6 4.6c.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4z"}));
}

DownChevron.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
